import { createStore } from "redux";
import { reducers } from "../../redux/reducer";
import persistReducers from "./persistReducers";
import { persistStore } from "redux-persist";
import { composeWithDevTools } from '@redux-devtools/extension';

// const persistant = persistReducer();
export const store = createStore(persistReducers(reducers), composeWithDevTools());

export const persistor = persistStore(store);
